// This will list all the scene available to the user depending on its rights

import React, { createContext, useState } from "react";

// Seed to be replace by a service here
const OrganisationSeed = {
        id: 'organization_id',
        name: 'My Brilliant Organisation',
        cognito_group_id: 'cognito_group_id',
        account: {
            limit: {
                APIKey: 10,
                renderer: 10,
            },
            date: {
                creation: '00/00/0001',
                updated: '00/00/0002',
                endDate: '00/00/0003'
            },
            scenes: [],
            borker_url: []
        }
    }

export const OrganisationContext = createContext();

export const OrganisationProvider = ({ children }) => {
  const [organisation, setOrganisation] = useState(OrganisationSeed);

  return (
    <OrganisationContext.Provider value={{ organisation }}>
      {children}
    </OrganisationContext.Provider>
  );
};
